<template>
  <div class="info-down__btn" @click="onClickInfo">
    <hammer-icon />
    <div class="is-16b">지적재산권의 안내</div>
  </div>
</template>

<script>
import HammerIcon from 'assets/svg/hammer-icon.vue'

export default {
  components: {HammerIcon},
  methods: {
    onClickInfo() {
      const routeData = this.$router.resolve('/terms?menu=2')
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.info-down__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #0058aa;
  padding: 12px 24px;
  justify-content: center;
  cursor: pointer;
  .is-16b {
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 125%; /* 20px */
  }
}
</style>
